import { QueryComponentModel } from "../../search/models/query-component";

const noiseWords = ["the", "and", "not", "near", "within", "before", "after", "or", "of", "a", "i", "v", "r", "r v"];

export class TermSanitiser {

    public static getSanitisedTermsList(components: QueryComponentModel[]): string[] {
        const termsList = this.getSearchTerms(components);
        const sanitisedTermsList = [];
        for (let index = 0; index < termsList.length; index++) {
            const term = termsList[index];
            if (term.toLowerCase() === "s" && index !== termsList.length) {
                this.getStatuteSectionTerms(term, termsList[index + 1], sanitisedTermsList);
                continue;
            }

            if (noiseWords.indexOf(term.toLowerCase()) === -1) {
                sanitisedTermsList.push(term);
            }
        }

        return sanitisedTermsList;
    }

    private static getSearchTerms(components: QueryComponentModel[]): string[] {
        const termList = [];
        if (components) {
            components.forEach((component) => {
                if (component.FieldName === "Title") {
                    termList.push(component.Resolution || component.Fragment);
                }

                if (component.FieldName === "Reference") {
                    termList.push(component.Resolution, this.replaceSquareBrackets(component.Resolution), component.Fragment);
                } else {
                    component.Fragment = component.Fragment.replace("'s", "");
                    const subComponents = component.Fragment.match(/\w+|"(?:\\"|[^"])+"/g);
                    if (subComponents && subComponents.length) {
                        for (let subComponent of subComponents) {
                            subComponent = subComponent.replace(/['"]+/g, "");
                            termList.push(subComponent);
                        }
                    }
                }
            });
        }
        return termList;
    }

    private static getStatuteSectionTerms(term: string, nextTerm: string, sanitisedTermsList: any[]) {
        const parsed = parseInt(nextTerm);
        if (!isNaN(parsed)) {
            sanitisedTermsList.push(term + " " + parsed);
            sanitisedTermsList.push(term + "." + parsed);
            sanitisedTermsList.push(term + ". " + parsed);
            sanitisedTermsList.push(term + parsed);
        }
    }

    private static replaceSquareBrackets(text: string) {
        // Replaces square brackets with round brackets for variation.
        return text.split(/[\[]/).join("(").split(/[\]]/).join(")");
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/helpers/search-term-sanitiser.ts